// import React, { useEffect } from "react";

// function ActiveTour() {
//   useEffect(() => {
//     if (window.pannellum) {
//       window.pannellum.viewer("panorama", {
//         type: "equirectangular",
//         panorama: "/360/0001.jpg",
//         autoLoad: true,
//         showZoomCtrl: true,
//         compass: true,
//         pitch: 10,
//         yaw: 180,
//         hfov: 110,
//       });
//     } else {
//       console.error("Pannellum library not loaded!");
//     }
//   }, []);

//   return (
//     <div
//       id="panorama"
//       style={{
//         width: "100%",
//         // height: "500px",
//         height: "calc(100vh - 86px)",
//         borderRadius: "10px",
//         overflow: "hidden",
//       }}
//     ></div>
//     // </div>
//   );
// }

// export default ActiveTour;
// import React, { useEffect, useRef } from "react";
// import compassBg from "../../assets/small.png";
// import compassArrow from "../../assets/Rectangle.svg";

// function ActiveTour() {
//   const compassRef = useRef(null);
//   const viewerRef = useRef(null);

//   const lastYawRef = useRef(0); // آخر زاوية من Pannellum
//   const rotationOffsetRef = useRef(0); // لتتبع الدوران المستمر
//   const animationFrameRef = useRef(null); // نخزن الـ animation frame

//   useEffect(() => {
//     if (window.pannellum) {
//       const viewer = window.pannellum.viewer("panorama", {
//         type: "equirectangular",
//         panorama: "/360/0001.jpg",
//         autoLoad: true,
//         showZoomCtrl: true,
//         compass: false,
//         pitch: 10,
//         yaw: 180,
//         hfov: 110,
//       });

//       viewerRef.current = viewer;

//       // شغل التحديث المستمر
//       const updateLoop = () => {
//         updateCompass(viewer);
//         animationFrameRef.current = requestAnimationFrame(updateLoop);
//       };
//       animationFrameRef.current = requestAnimationFrame(updateLoop);
//     } else {
//       console.error("Pannellum library not loaded!");
//     }

//     // نظافة لما يتقفل الكمبوننت
//     return () => {
//       if (animationFrameRef.current) {
//         cancelAnimationFrame(animationFrameRef.current);
//       }
//     };
//   }, []);

//   const updateCompass = (viewer) => {
//     if (!compassRef.current) return;

//     const currentYaw = viewer.getYaw();

//     // الفرق بين الزاوية الحالية والسابقة
//     let delta = currentYaw - lastYawRef.current;

//     // تصحيح القفزة عند الانتقال من -180 إلى 180
//     if (delta > 180) delta -= 360;
//     if (delta < -180) delta += 360;

//     // أضف الفرق إلى الدوران المستمر
//     rotationOffsetRef.current += delta;

//     // خزن الزاوية الحالية
//     lastYawRef.current = currentYaw;

//     // طبق التدوير على السهم
//     compassRef.current.style.transform = `rotate(${rotationOffsetRef.current}deg)`;
//   };

//   return (
//     <div style={{ position: "relative", width: "100%", height: "calc(100vh - 86px)" }}>
//       {/* Panorama */}
//       <div
//         id="panorama"
//         style={{
//           width: "100%",
//           height: "100%",
//           borderRadius: "10px",
//           overflow: "hidden",
//         }}
//       ></div>

//       {/* Compass */}
//       <div
//         style={{
//           position: "absolute",
//           bottom: "20px",
//           right: "20px",
//           width: "80px",
//           height: "80px",
//           zIndex: 9999,
//         }}
//       >
//         {/* الخلفية الثابتة */}
//         <div
//           style={{
//             position: "absolute",
//             width: "100%",
//             height: "100%",
//             background: `url(${compassBg}) no-repeat center center`,
//             backgroundSize: "contain",
//             zIndex: 1,
//           }}
//         ></div>

//         {/* السهم المتحرك */}
//         <div
//           ref={compassRef}
//           style={{
//             position: "absolute",
//             width: "30px",
//             height: "30px",
//             background: `url(${compassArrow}) no-repeat center center`,
//             backgroundSize: "contain",
//             zIndex: 2,
//             transition: "transform 0.05s linear",
//           }}
//         ></div>
//       </div>
//     </div>
//   );
// }

// export default ActiveTour;

// import React, { useEffect, useRef } from "react";
// import SmallTour from "./smallTour";
// import "./style/smallTour.css"
// function ActiveTour() {
//   const viewerRef = useRef(null);
//   const lastYawRef = useRef(0);
//   const rotationOffsetRef = useRef(0);
//   const animationFrameRef = useRef(null);

//   // دالة تحديث اتجاه البوصلة
//   const updateCompass = (viewer) => {
//     const currentYaw = viewer.getYaw();

//     // الفرق بين الزاوية الحالية والسابقة
//     let delta = currentYaw - lastYawRef.current;

//     // تصحيح القفزة عند الانتقال من -180 إلى 180
//     if (delta > 180) delta -= 360;
//     if (delta < -180) delta += 360;

//     // تحديث الدوران المستمر
//     rotationOffsetRef.current += delta;
//     lastYawRef.current = currentYaw;

//     return rotationOffsetRef.current;
//   };

//   useEffect(() => {
//     if (window.pannellum) {
//       const viewer = window.pannellum.viewer("panorama", {
//         type: "equirectangular",
//         panorama: "/360/0001.jpg",
//         autoLoad: true,
//         showZoomCtrl: true,
//         compass: false,
//         pitch: 10,
//         yaw: 180,
//         hfov: 110,
//       });

//       viewerRef.current = viewer;

//       const updateLoop = () => {
//         updateCompass(viewer);
//         animationFrameRef.current = requestAnimationFrame(updateLoop);
//       };
//       animationFrameRef.current = requestAnimationFrame(updateLoop);
//     } else {
//       console.error("Pannellum library not loaded!");
//     }

//     // تنظيف عند إغلاق الكومبوننت
//     return () => {
//       if (animationFrameRef.current) {
//         cancelAnimationFrame(animationFrameRef.current);
//       }
//     };
//   }, []);

//   return (
//     <div style={{ position: "relative", width: "100%", height: "calc(100vh - 86px)" }}>
//       {/* Panorama Viewer */}
//       <div
//         id="panorama"
//         style={{
//           width: "100%",
//           height: "100%",
//           borderRadius: "10px",
//           overflow: "hidden",
//         }}
//       ></div>

//       {/* البوصلة منفصلة */}
//       <SmallTour getViewer={() => viewerRef.current} />
//     </div>
//   );
// }

// export default ActiveTour;

// 14/1 الجولة الستاتيك
// import React, { useEffect, useRef, useState } from "react";
// import Controls from "./Controls";
// import SmallTour from "./smallTour";
// import RoomsUnit from "./roomsunit";
// // import "./style/smallTour.css";

// function ActiveTour({ apiEndpoint = "/mock-scenes.json", isMobile }) {
//   const viewerRef = useRef(null);
//   const [scenes, setScenes] = useState([]);
//   const [currentSceneId, setCurrentSceneId] = useState(null);
//   const [loadingScenes, setLoadingScenes] = useState(true);
//   const overlayRef = useRef(null);

//   // --- 1. جلب البيانات من الباك
//   useEffect(() => {
//     let cancelled = false;
//     fetch(apiEndpoint)
//       .then((r) => r.json())
//       .then((data) => {
//         if (cancelled) return;
//         setScenes(data);
//         setCurrentSceneId(data[0]?.id ?? null);
//         setLoadingScenes(false);
//         // نعمل preload للصورة الأولى بشكل سريع
//         preloadImages(data.map((s) => s.image));
//       })
//       .catch((e) => {
//         console.error("Failed to fetch scenes", e);
//         setLoadingScenes(false);
//       });
//     return () => {
//       cancelled = true;
//     };
//   }, [apiEndpoint]);

//   // --- 2. Preload helper (simple)
//   const preloadImages = (urls = []) => {
//     urls.forEach((u) => {
//       const img = new Image();
//       img.src = u;
//     });
//   };

//   // --- 3. Initialize Pannellum after scenes loaded
//   useEffect(() => {
//     if (loadingScenes) return;
//     if (!window.pannellum) {
//       console.error("Pannellum not loaded!");
//       return;
//     }
//     if (!scenes.length) return;

//     // build config
//     const config = {
//       default: {
//         firstScene: currentSceneId || scenes[0].id,
//         autoLoad: true,
//         showZoomCtrl: true,
//         compass: false,
//       },
//       scenes: {},
//     };

//     scenes.forEach((scene) => {
//       config.scenes[scene.id] = {
//         panorama: scene.image,
//         pitch: scene.initialView?.pitch ?? 0,
//         yaw: scene.initialView?.yaw ?? 0,
//         hfov: scene.initialView?.hfov ?? 100,
//         hotSpots: (scene.hotspots || []).map((h, idx) => ({
//           pitch: h.pitch,
//           yaw: h.yaw,
//           type: h.type || "scene",
//           text: h.text || "",
//           // نستخدم cssClass لعرض custom marker عبر CSS
//           cssClass: "custom-hotspot",
//           createTooltipFunc: hotspotTooltip, // function below
//           createTooltipArgs: { icon: h.icon, text: h.text, target: h.target },
//           clickHandlerFunc: (evt, args) => {
//             if (h.type === "scene") {
//               loadScene(h.target);
//             } else {
//               // handle other hotspot types
//               console.log("hotspot clicked", h);
//             }
//           },
//         })),
//       };
//     });

//     // create viewer
//     console.log("Scenes in config:", config.scenes);

//     const viewer = window.pannellum.viewer("panorama", config);
//     viewerRef.current = viewer;

//     // ensure overlay hidden initially
//     if (overlayRef.current) overlayRef.current.style.opacity = 0;

//     // cleanup
//     return () => {
//       try {
//         viewer.destroy();
//       } catch (e) {}
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [loadingScenes, scenes]);

//   // --- Tooltip creator (Pannellum API expects function accessible globally or passed)
//   // We'll attach to window so Pannellum can call it (some bundles require global)
//   useEffect(() => {
//     window.hotspotTooltip = hotspotTooltip;
//     return () => {
//       delete window.hotspotTooltip;
//     };
//   }, []);

//   // createTooltipFunc implementation (returns DOM element)
//   function hotspotTooltip(hotSpotDiv, args) {
//     // args: { icon, text, target }
//     // Build a small DOM for hotspot (image + label)
//     const container = document.createElement("div");
//     container.className = "hotspot-tooltip-wrapper";

//     const btn = document.createElement("button");
//     btn.className = "hotspot-btn";
//     btn.style.cursor = "pointer";
//     btn.title = args.text || "";

//     const img = document.createElement("img");
//     img.className = "hotspot-icon";
//     img.src = args.icon || "/icons/hotspot.png";
//     img.alt = args.text || "hotspot";

//     const label = document.createElement("div");
//     label.className = "hotspot-label";
//     label.textContent = args.text || "";

//     btn.appendChild(img);
//     container.appendChild(btn);
//     container.appendChild(label);

//     // ensure pannellum knows this element is the tooltip
//     hotSpotDiv.appendChild(container);
//     return container;
//   }

//   // --- 4. loadScene with transition + preload target
//   const loadScene = (sceneId) => {
//     if (!viewerRef.current) return;
//     if (sceneId === currentSceneId) return;

//     const targetScene = scenes.find((s) => s.id === sceneId);
//     if (!targetScene) return;
//     console.log("Loading scene directly:", sceneId);

//     // show overlay (fade-in) while preloading
//     if (overlayRef.current) {
//       overlayRef.current.style.transition = "opacity 300ms ease";
//       overlayRef.current.style.opacity = 1;
//     }

//     // preload target panorama image
//     const img = new Image();
//     img.src = targetScene.image;
//     img.onload = () => {
//       // use Pannellum scene load with transition true
//       try {
//         viewerRef.current.loadScene(sceneId);
//       } catch (e) {
//         // fallback
//         viewerRef.current.setPanorama(targetScene.image, null, 300);
//       }
//       setCurrentSceneId(sceneId);

//       // hide overlay after small delay so transition looks smooth
//       setTimeout(() => {
//         if (overlayRef.current) overlayRef.current.style.opacity = 0;
//       }, 350);
//     };
//     img.onerror = () => {
//       console.error("Failed to preload", targetScene.image);
//       if (overlayRef.current) overlayRef.current.style.opacity = 0;
//     };
//   };

//   // --- 5. Controls API for yaw/pitch/hfov usage
//   const setYaw = (deg) => {
//     if (!viewerRef.current) return;
//     const pitch = viewerRef.current.getPitch();
//     const hfov = viewerRef.current.getHfov();
//     viewerRef.current.lookAt({ pitch, yaw: deg, hfov });
//   };
//   const setPitch = (deg) => {
//     if (!viewerRef.current) return;
//     const yaw = viewerRef.current.getYaw();
//     const hfov = viewerRef.current.getHfov();
//     viewerRef.current.lookAt({ pitch: deg, yaw, hfov });
//   };
//   const setHfov = (val) => {
//     if (!viewerRef.current) return;
//     viewerRef.current.setHfov(val);
//   };

//   if (loadingScenes) return <div>Loading tour data...</div>;
//   if (!scenes.length) return <div>No scenes available</div>;

//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         height: isMobile ? "100%" : "calc(100vh - 86px)",
//       }}
//     >
//       {/* Overlay for transitions */}
//       <div
//         ref={overlayRef}
//         style={{
//           position: "absolute",
//           inset: 0,
//           background: "#000",
//           opacity: 1,
//           pointerEvents: "none",
//           transition: "opacity 300ms ease",
//           zIndex: 50,
//         }}
//       />

//       {/* Panorama container */}
//       <div id="panorama" style={{ width: "100%", height: "100%" }} />

//       {/* Top-left current scene name */}
//       <div
//         style={{
//           position: "absolute",
//           left: 16,
//           top: 16,
//           zIndex: 60,
//           background: "rgba(0,0,0,0.5)",
//           color: "#fff",
//           padding: "8px 12px",
//           borderRadius: 8,
//           fontWeight: 600,
//         }}
//       >
//         {scenes.find((s) => s.id === currentSceneId)?.name}
//       </div>

//       <Controls
//         onSetYaw={setYaw}
//         onSetPitch={setPitch}
//         onSetHfov={setHfov}
//         getViewer={() => viewerRef.current}
//       />
//       <div
//         style={{
//           position: "absolute",
//           inset: 0,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "flex-end",
//           pointerEvents: "none",
//         }}
//       >
//         <div
//           style={{
//             position: "relative",
//             width: "100%",
//             pointerEvents: "auto",
//             padding: "16px",
//             right: 0,
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               justifyContent: "flex-end",
//             }}
//           >
//             <SmallTour
//               getViewer={() => viewerRef.current}
//               scenes={scenes}
//               currentSceneId={currentSceneId}
//               onSelectScene={loadScene}
//             />
//           </div>

//           <div
//             style={{
//               alignSelf: "center",
//               overflow: "hidden",
//               justifyContent: "center",
//               display: "flex",
//             }}
//           >
//             <RoomsUnit />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ActiveTour;

// جولة الكولا مظبووووطة
// import React from "react";
// import RoomsUnit from "./roomsunit";

// function ActiveTour() {
//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         // height: "calc(100vh - 86px)",
//          height:  "calc(-50px + 100vh)",
//         overflow: "hidden",
//         userSelect: "none",
//       }}
//     >
//       {/* Kuula Embed */}
//       <iframe
//         title="Kuula Tour"
//         src="https://kuula.co/share/collection/7lPZ8?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1"
//         frameBorder="0"
//         allowFullScreen
//         style={{ width: "100%", height: "100%" }}
//       />

//       {/* Overlay */}
//       <div
//         style={{
//           position: "absolute",
//           // inset: 0,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           justifyContent: "flex-end",
//           // pointerEvents: "none",
//         }}
//       >
//         <div
//           style={{
//             position: "relative",
//             width: "100%",
//             // pointerEvents: "auto",
//             padding: "16px",
//           }}
//         >
//           <div style={{ alignSelf: "center", overflow: "hidden" }}>
//             <RoomsUnit />
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ActiveTour;
// import React from "react";        // ✅ import في الأعلى
// import RoomsUnit from "./roomsunit";
// import { useZone } from "../../context/ZoneContext";

// function ActiveTour({ selectedUnitId }) {
//   const { units } = useZone();

//   // جرب تعديل السطر ده في الكود عندك
// const selectedUnit = units.find((u) => String(u.id) === String(selectedUnitId));
//   const tourUrl = selectedUnit?.type?.tour_link;
// console.log("Units Array:", units);
// console.log("Selected ID from Prop:", selectedUnitId, typeof selectedUnitId);
// console.log("Found Unit:", selectedUnit);
//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         height: "calc(-50px + 100vh)",
//         overflow: "hidden",
//         backgroundColor: "#f0f0f0",
//       }}
//     >
//       {tourUrl ? (
//         <iframe
//           key={tourUrl}
//           title="Kuula Tour"
//           src={tourUrl}
//           frameBorder="0"
//           allowFullScreen
//           style={{ width: "100%", height: "100%" }}
//         />
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             color: "#666",
//           }}
//         >
//           <p>عفواً، لا يوجد جولة افتراضية متاحة لهذه الوحدة حالياً</p>
//         </div>
//       )}

//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           right: 0,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           padding: "16px",
//           pointerEvents: "none",
//         }}
//       >
//         <div style={{ pointerEvents: "auto" }}>
//           <RoomsUnit villa={selectedUnit} />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default ActiveTour;  // ✅ export في الأسفل


import React from "react";
import RoomsUnit from "./roomsunit";

// استلمنا villa كـ Prop مباشرة
function ActiveTour({ villa, isMobile }) {
  
  // بناخد الرابط من الـ villa اللي مبعوتة من الأب
  const tourUrl = villa?.type?.tour_link;

  // Debugging عشان نشوف البيانات واصلة هنا ولا لأ
  console.log("Villa received in ActiveTour:", villa);
  console.log("Tour URL:", tourUrl);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "calc(-50px + 100vh)",
        overflow: "hidden",
        backgroundColor: "#f0f0f0",
      }}
    >
      {tourUrl ? (
        <iframe
          key={tourUrl}
          title="Kuula Tour"
          src={tourUrl}
          frameBorder="0"
          allowFullScreen
          style={{ width: "100%", height: "100%" }}
        />
      ) : (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "#666",
            padding: "20px",
            textAlign: "center"
          }}
        >
          {!villa ? (
            <p>جاري تحميل بيانات الوحدة...</p>
          ) : (
            <p>عفواً، لا يوجد جولة افتراضية متاحة لهذه الوحدة حالياً</p>
          )}
        </div>
      )}

      {/* <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: "16px",
          pointerEvents: "none",
        }}
      >
        <div style={{ pointerEvents: "auto" }}>
          <RoomsUnit villa={villa} />
        </div>
      </div> */}
    </div>
  );
}

export default ActiveTour;




















// import React from "react";
// import RoomsUnit from "./roomsunit";
// import { useZone } from "../../context/ZoneContext";

// function ActiveTour({ selectedUnitId }) {
//   const { units } = useZone();

//   const selectedUnit = units.find((u) => u.id === selectedUnitId);
//   const tourUrl = selectedUnit?.type?.tour_link; 

//   return (
//     <div
//       style={{
//         position: "relative",
//         width: "100%",
//         height: "calc(-50px + 100vh)",
//         overflow: "hidden",
//         backgroundColor: "#f0f0f0", 
//       }}
//     >
//       {tourUrl ? (
//         <iframe
//           key={tourUrl}
//           title="Kuula Tour"
//           src={tourUrl}
//           frameBorder="0"
//           allowFullScreen
//           style={{ width: "100%", height: "100%" }}
//         />
//       ) : (
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             height: "100%",
//             color: "#666",
//           }}
//         >
//           <p>عفواً، لا يوجد جولة افتراضية متاحة لهذه الوحدة حالياً</p>
//         </div>
//       )}

//       <div
//         style={{
//           position: "absolute",
//           bottom: 0,
//           left: 0,
//           right: 0,
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           padding: "16px",
//           pointerEvents: "none", 
//         }}
//       >
//         <div style={{ pointerEvents: "auto" }}>
//           <RoomsUnit villa={selectedUnit} />
//         </div>
//       </div>
//     </div>
//   );
// }
// export default ActiveTour;
